module.exports = __webpack_public_path__ + "static/media/fbIcon.b98cad99.svg";